import { render, staticRenderFns } from "./ScatterFarmacias.vue?vue&type=template&id=4dde06b8"
import script from "./ScatterFarmacias.vue?vue&type=script&lang=js"
export * from "./ScatterFarmacias.vue?vue&type=script&lang=js"
import style0 from "./ScatterFarmacias.vue?vue&type=style&index=0&id=4dde06b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports